import { render, staticRenderFns } from "./CreateNewTeamFolder.vue?vue&type=template&id=7fe9a516&scoped=true"
import script from "./CreateNewTeamFolder.vue?vue&type=script&lang=js"
export * from "./CreateNewTeamFolder.vue?vue&type=script&lang=js"
import style0 from "./CreateNewTeamFolder.vue?vue&type=style&index=0&id=7fe9a516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe9a516",
  null
  
)

export default component.exports